﻿import { GetBreakpointWidth } from 'Utils/globals-bp';
import { PAGE_NAV_SHADOW_HEIGHT } from 'Utils/constants';

export function ScrollToSearchBarForDropDown($dropdown, forceModalScrolling, callBack) {
    // This function is used after qtip.hide() 
    // when select dropdown-option or autocomplete-item inside dropdown
    var isModalMode = false;
    var api = $dropdown ? $dropdown.qtip('api') : null;
    var $dropdownContainerQtip = api != null ? api.tooltip : null;

    if (!forceModalScrolling && $dropdownContainerQtip && $dropdownContainerQtip.length > 0) {
        isModalMode = $dropdownContainerQtip.hasClass("modal");
    }

    if (isModalMode) {
        //var scrollTop = $dropdown.attr("data-last-top") || null;
        //if (scrollTop != null && $.isNumeric(scrollTop) && scrollTop >= 0) {
        //    $('html, body').stop().delay(10).animate({
        //        scrollTop: parseInt(scrollTop)
        //    }, 0);
        //}
    } else {
        var top = $(window).scrollTop() || $('html, body').scrollTop();
        var $search = $dropdown ? $dropdown.closest(".search") : $(".search:first");
        if (!$search || ($search && $search.length < 1)) {
            // Get quit if parent searchBar is not found
            return;
        }
        var scrollTop = $search.offset().top;

        if (GetBreakpointWidth() <= 768) {
            //Remark: 
            // 1) siteHeadRoom works while GetBreakpointWidth() < 768
            // 2) '.site-header' is fixed to top until GetBreakpointWidth() <= 768

            // Give space for siteHeadRoom if it's used
            let $siteHeader = $('.site-header');
            if (global.siteHeadRoom != null && $siteHeader.length > 0) {
                var height = $siteHeader.outerHeight();
                scrollTop -= height;
            }
        } else {
            //check Page-Nav sticky
            var $pageNav = $(".page-nav");
            if ($pageNav.length > 0) {
                let $stickyPageNav = $pageNav.closest(".sticky-wrapper");
                if ($stickyPageNav.length > 0) {
                    var offset = $stickyPageNav.offset().top;
                    var height = $stickyPageNav.outerHeight();
                    //check if $search before/after $pageNav
                    if (scrollTop > offset && height > 0) {
                        // In case when current searchBar is located after pageNav and pageNav is visible (sticky.height > 0)
                        // cut height on scrolling
                        scrollTop -= (height + PAGE_NAV_SHADOW_HEIGHT);
                    }
                }
            }
        }

        //check searchBar is out of screen and scroll if need it
        if (top > scrollTop) {
            // Details: http://api.jquery.com/animate/
            //complete
            // Type: Function()
            //A function to call once the animation is complete, called once per matched element.
            //var completeCallback = (callBack && typeof callBack === 'function') ? callBack : function () { };
            // 1) keep 'html, body' because some browsers work only with one of this HTML tags
            // 2) anyway, 'callBack' must be executed only once
            var flgExecuted = false;
            var completeCallback = function () {
                if (flgExecuted)
                    return;
                flgExecuted = true;

                if (!callBack && typeof callBack !== 'function')
                    return;
                callBack.apply(this, arguments);
            };
            $('html, body').stop().delay(100).animate({
                scrollTop: scrollTop
            }, 100, completeCallback);
            return;
        }
    }

    if (callBack && typeof callBack === 'function')
        callBack();

};

export function GetPositionContainerOfDropDownPricing(data) {
    if (!data || data === '')
        return false;

    if (data == 'filtering-on-map') {
        return "#sidebarMapFilters"
    }

    if (data == 'filtering') {
        return "PARENT_CONTAINER";
    }

    return false;
};
